<mat-card appearance="outlined" class="mb-10 col-sm-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
  <mat-card-header>
        <mat-card-title>
            <mat-icon>category</mat-icon> Extension Activities
        </mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <p>
            TODO: SERVICE
        </p>
    </mat-card-content>
</mat-card>
